export const naturalNumbers = {
  mask: Number,
  scale: 0,
  signed: false,
  min: 0,
  max: 10000000000,
  thousandsSeparator: ' ',
  unmask: 'typed'
}
